export default __webpack_public_path__ + "fonts/9827c29b2f4674d06db9737d9c84b59a.eot";